export default __webpack_public_path__ + "static/media/modal-editar.3816b3c2.svg";